import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinSubAccount = createAsyncThunk(
    "subAccount/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterSubAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getSubAccount = createAsyncThunk(
    "subAccount/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterSubAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertSubAccount = createAsyncThunk(
    "subAccount/insert",
    async ({MainAccountID, SubAccount, SubAccountID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("MainAccountID", MainAccountID);
        formData.append("SubAccount", SubAccount);
        formData.append("SubAccountID", SubAccountID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterSubAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateSubAccount = createAsyncThunk(
    "subAccount/update",
    async ({MainAccountID, SubAccount, SubAccountID, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("MainAccountID", MainAccountID);
        formData.append("SubAccount", SubAccount);
        formData.append("SubAccountID", SubAccountID);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterSubAccount',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const subAccountSlice = createSlice({
    name: "subAccount",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinSubAccount.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinSubAccount.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinSubAccount.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getSubAccount.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getSubAccount.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getSubAccount.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertSubAccount.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertSubAccount.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertSubAccount.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateSubAccount.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateSubAccount.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateSubAccount.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const subAccountSelector = (state) => state.subAccount;
